/** 浏览器 <script> 直引 UMD 时无 Node 的 process */
if (typeof globalThis !== 'undefined' && (globalThis as unknown as { process?: unknown }).process == null) {
  ;(globalThis as unknown as { process: { env: Record<string, string> } }).process = {
    env: { NODE_ENV: 'production' },
  }
}
